<template>
  <div class="container">
    <div class="title">
      <span
        ><i class="iconfont icon-fanhui-" @click="_tobackPage"></i
        >问卷调查</span
      >
    </div>
    <div class="body">
      <div class="success"></div>
      <button style="margin-top: 20px" @click="_toHomePage">返回首页</button>
    </div>
    <div class="qa">
      <div class="img"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  methods: {
    _toHomePage() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.container {
  height: 100%;
}

.title {
  width: 100%;
  height: 70px;
  background-color: #1242fc;
  color: #fff;
  font-size: 18px;
  line-height: 70px;
  text-align: center;
}

.title i {
  float: left;
  margin-left: 10px;
  position: relative;
}

.title span {
  width: 100%;
  position: absolute;
  top: 12px;
  left: 1px;
}

.body {
  width: 100%;
  height: calc(100% - 180px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* background-color: pink; */
}

.body button {
  width: 125px;
  height: 30px;
  color: #fff;
  background-color: #1242fc;
  border: none;
  border-radius: 2px;
}

.success {
  width: 125px;
  height: 125px;
  background-image: url(@/assets/images/success.png);
  background-repeat: no-repeat;
  background-size: contain;
}

.qa {
  width: 100%;
  height: 140px;
  display: flex;
  justify-content: center;
}

.qa .img {
  width: 140px;
  height: 140px;
  background-image: url(@/assets/images/qa.png);
  background-repeat: no-repeat;
  background-size: contain;
}
</style>
